import React from "react"
import Dropzone from "react-dropzone"
import { Button } from "reactstrap"

class InputFile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.uploading === true && this.props.uploading === false) {
            this.setState({
                file: null
            });
        }
    }

    deleteFile = (stateName) => {
        this.setState({
            [stateName]: null,
        })
    }

    render() {

        const { title='', onUpload=() => {}, uploading=false, value='', onDelete=() => {} } = this.props;
        if(uploading) {
            return  <div className="input-content">
                <h5 className="teste">{title}</h5>
                <span>Uploading...</span>
            </div>
        }

        const {disabled} = this.props;
        return (
            <div className="input-content">
                <h5 className="teste">{title}</h5>
                <div>
                    {!this.state.file ? (
                        <>
                            
                            {!!value ? <div className="d-flex align-items-center">
                                <Button
                                    className="btn-round "
                                    color="secondary"
                                    onClick={() => window.open(value)}
                                    disabled={disabled}
                                >
                                    View{" "}
                                    <i className="tim-icons icon-upload" />
                                </Button>
                                <Button
                                    className="btn-round px-4"
                                    color="danger"
                                    onClick={() => onDelete(value)}
                                    disabled={disabled}
                                >
                                    <i className="tim-icons icon-trash-simple" />
                                </Button>
                            </div> :
                            <Dropzone
                                onDrop={(acceptedFiles) =>
                                    this.setState({
                                        file: acceptedFiles,
                                    })
                                }
                                disabled={disabled}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <section>
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <Button
                                                className="btn-round"
                                                color="primary"
                                                disabled={disabled}
                                            >
                                                Upload{" "}
                                                <i className="tim-icons icon-upload" />
                                            </Button>
                                        </div>
                                    </section>
                                )}
                            </Dropzone>}
                        </>
                    ) : (
                        <div className="d-flex align-items-center">
                            <a href={this.state.file[0].path} target="_blank" rel="noopener noreferrer">
                                <h5>{this.state.file[0].path}</h5>
                            </a>
                            <Button
                                className="btn-round btn-icon"
                                color="primary"
                                disabled={disabled}
                            >
                                <i
                                    className="tim-icons icon-check-2"
                                    onClick={() => onUpload(this.state.file[0])}
                                />
                            </Button>
                            <Button
                                className="btn-round btn-icon"
                                color="primary"
                                disabled={disabled}
                            >
                                <i
                                    className="tim-icons icon-trash-simple"
                                    onClick={() => this.deleteFile("file")}
                                />
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default InputFile
